import {
  CardImgEasyFollowBuildSprints,
  CardImgEasyFollowDesignPurpose,
  CardImgEasyFollowKickoffPlan,
  CardImgEasyFollowLaunchScale,
} from "@/lib/images";
import { StaticImageData } from "next/image";

// Heading
export const Heading_Section_Easy_Follow = {
  heading: "Easy-to-follow. Built to deliver.",
};

// Scroll Card List Item Data

interface IScrollCardSectionEasyFollow {
  img: StaticImageData;
  title: string;
  sub_title: string;
  desc: string;
}

export const Scroll_Card_Section_Easy_Follow: IScrollCardSectionEasyFollow[] = [
  {
    title: "Kickoff & Plan 🧭 ",
    sub_title: "Set up your vision in minutes",
    desc: "Define goals, key features, and success metrics to create a roadmap tailored to your business.",
    img: CardImgEasyFollowKickoffPlan,
  },
  {
    title: "Design with Purpose 🎨",
    sub_title: "Intuitive interfaces, stunning experiences",
    desc: "We design clean, user-friendly flows that keep your users engaged and your brand memorable.",
    img: CardImgEasyFollowDesignPurpose,
  },
  {
    title: "Build in Sprints 🛠️ ",
    sub_title: "Faster iterations, fewer blockers",
    desc: "Using agile methodology, we develop high-quality, test-ready features in weekly or bi-weekly cycles.",
    img: CardImgEasyFollowBuildSprints,
  },
  {
    title: "Launch & Scale ✈️",
    sub_title: "From launch to lift-off and beyond",
    desc: "We deploy with confidence and support post-launch updates, feedback loops, and feature scaling.",
    img: CardImgEasyFollowLaunchScale,
  },
];
